import { ArrowRight, Clock } from "lucide-react";
import { Card, CardContent } from "@/common/components/ui/card";
import { Button } from "@/common/components/ui/button";
import { Badge } from "../ui/badge";
import { NewsItem } from "../../types/news";

interface NewsCardProps {
  item: NewsItem;
  onReadMore: (item: NewsItem) => void;
}

export const NewsCard = ({ item, onReadMore }: NewsCardProps) => {
  return (
    <Card className="group flex h-full flex-col overflow-hidden border-slate-200 bg-white transition-all duration-500 hover:border-[#66A0CD]/40 hover:shadow-xl">
      <CardContent className="flex h-full flex-col p-0">
        <div className="flex flex-grow flex-col p-6">
          <div className="mb-4 flex items-center justify-between">
            <Badge
              variant="secondary"
              className="justify-end border-none bg-slate-100 px-2 py-1 align-middle text-[9px] font-black uppercase tracking-wider text-slate-500 hover:bg-slate-200"
            >
              {item.category}
            </Badge>
            <div className="flex items-center gap-1.5 text-slate-400">
              <Clock className="h-3 w-3" />
              <span className="text-[9px] font-bold uppercase tracking-tight">
                {item.time}
              </span>
            </div>
          </div>

          <h3 className="mb-3 line-clamp-2 text-xl font-black leading-tight text-[#0c4a6e] transition-colors group-hover:text-[#66A0CD]">
            {item.title}
          </h3>
          {item.caption && (
            <p className="mb-6 text-xs font-medium leading-relaxed text-slate-400">
              {item.caption}
            </p>
          )}

          <div className="mt-auto flex items-center justify-end border-t border-slate-50 pt-4">
            <Button
              variant="ghost"
              size="sm"
              className="group/btn flex items-center gap-1 p-0 text-[10px] font-black uppercase tracking-wider text-[#175d80] hover:bg-transparent hover:text-[#66A0CD]"
              onClick={() => onReadMore(item)}
            >
              Analysis{" "}
              <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover/btn:translate-x-1" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
